var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGiftBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gift box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discount-code",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---Discount-code-applied",
    transform: "translate(-490.000000, -101.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.7,107.8 L505.3,107.8 L505.3,116.64 L491.7,116.64 L491.7,107.8 Z M497.82,107.8 L499.18,107.8 L499.18,116.64 L497.82,116.64 L497.82,107.8 Z M498.139951,103.717874 L496.066251,103.717874 C494.597709,103.717874 493.767718,101.93649 495.062286,101.162381 C495.907887,100.656739 496.989571,101.343391 498.377342,103.063042 C499.851142,101.343391 500.999879,100.656739 501.897899,101.162381 C503.272717,101.93649 502.391274,103.717874 500.831698,103.717874 L498.139951,103.717874 Z M490,103.72 L507,103.72 L507,106.439764 L490,106.439764 L490,103.72 Z",
    id: "gift-box"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftBox);
export default __webpack_public_path__ + "static/media/icon_gift_box.07c994516eb4c26935f6905aef2a11b8.svg";
export { ForwardRef as ReactComponent };